var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinanceChainWalletLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9426 24L6.96913 28.9691L2 24L6.96913 19.0309L11.9426 24ZM24 11.934L32.5154 20.4537L37.4846 15.4846L24 2L10.5154 15.4846L15.4846 20.4537L24 11.934ZM41.0352 19.0309L36.066 24L41.0352 28.9691L46 24L41.0352 19.0309ZM24 36.066L15.4846 27.5506L10.5154 32.5154L24 46L37.4846 32.5154L32.5154 27.5506L24 36.066ZM24 28.9691L28.9691 24L24 19.0309L19.0309 24L24 28.9691Z",
    fill: "#F0B90B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceChainWalletLogo);
export default __webpack_public_path__ + "static/media/binanceChainWalletLogo.1faa8ace.svg";
export { ForwardRef as ReactComponent };